import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { useResponsive } from 'Components/utils/responsive/ResponsiveContext';
import { t } from 'Src/i18n';
const PROPOSAL_SEARCH_ERROR_MAPPING = {
  invalidProductId: 'calendar.resortNotOnSale',
  invalidBookingCriteria: 'invalidBookingCriteria',
  noAccommodation: 'noAccommodation',
  noProposalAvailable: 'noProposalAvailable',
  noProposalWithFlight: 'noProposalWithFlight',
  notOnSaleForThePeriod: 'calendar.resortNotOnSale',
  noTransport: 'noTransport',
  technicalError: 'technicalError',
  unableToMakeProposal: 'unableToMakeProposal',
  unavailableForBirthdates: 'ageIncorrectOrUnauthorized',
};
type Props = {
  className?: string;
  errorCode: string | null | undefined;
};
export const BookingErrors = ({ className, errorCode }: Props) => {
  const { isTablet } = useResponsive();
  return (
    <div
      className={classnames(
        {
          'arrow-upRight arrow-large arrow-lightSand arrow-bg arrow-bg-lightGrey md:relative md:border-t-1':
            isTablet,
        },
        className,
      )}
      id="Package-error"
    >
      <div className="m-auto text-center text-20 text-red md:max-w-1/2 md:py-25">
        {errorCode && PROPOSAL_SEARCH_ERROR_MAPPING[errorCode]
          ? t(`booking.accommodation.errorMessages.${PROPOSAL_SEARCH_ERROR_MAPPING[errorCode]}`)
          : t('booking.accommodation.errorMessageNoProposal')}
      </div>
    </div>
  );
};
